// UserAlertAdd.jsx
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Sidemenu from '../base/sidemenu';
import moment from "moment";
import { submitEmergencyLog } from "../../services/userApiServicer"; // ✅ 신규 등록 API import

export default function UserAlertAdd() {
  const { state } = useLocation();
  const navigate = useNavigate();
const { user_id: userId, admin_id: adminId } = state || {};
  const [content, setContent] = useState("");
  const token = localStorage.getItem("token");

  const handleCreate = async () => {
    if (!content.trim()) {
      alert("내용을 입력해주세요.");
      return;
    }
    
    try {
        const data = await submitEmergencyLog({
        token,
        user_id: userId,
        content,
        admin_id: adminId,
       });
       console.log("등록 요청 데이터:", { user_id: userId, admin_id: adminId, content });

      if (data.success === false) {
        alert(data.message);
        return;
      }

      alert("등록이 완료되었습니다.");
      navigate(-1);
    } catch (error) {
      alert("등록 실패");
    }
  };

  return (
    <div className='flex'>
      <Sidemenu />
      <div className="user">
        <h1>응급상황 기록 등록</h1>
        <div className="user_box">
          <div className="user_alert_edit">
            <h2 className="subpage_title">
              응급상황 등록 (기준일: {moment().format('YYYY-MM-DD')})
            </h2>
            <div className="formbox">
              <label>증상 및 상황조치</label>
              <textarea
                value={content}
                onChange={(e) => setContent(e.target.value)}
                rows={10}
                style={{ width: "100%", resize: "vertical" }}
              />
            </div>
            <div className="btn-group">
              <button className="btncolor04" onClick={handleCreate}>저장</button>
              <button className="btncolor01" onClick={() => navigate(-1)}>취소</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
